<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
      <div>
        <div class="flex items-center gap-1">
          <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
            <button mat-icon-button color="primary">
              <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
            </button>
          </div>

          <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
            <div class="p-4">
              <p>
                Categorías para ordenar los materiales.
                Permite agrupar productos por familia o
                tipo y aplicar reglas/reportes por grupo.
                Úsalo para segmentar líneas de producto.
              </p>
            </div>
          </mat-menu>
          <h2 class="text-xl font-semibold leading-8 tracking-tight">
            Grupos
          </h2>

        </div>


        <div class="text-sm text-secondary font-medium tracking-tight">
          Activa/inactiva, crea, actualiza y elimina los <b>grupos de materiales</b> que operan dentro de AVE.
        </div>
      </div>
      <!-- Header -->
      <div class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
        <div class="flex shrink-0">
          <!-- Title -->
          <!--<div class="text-3xl font-extrabold tracking-tight">
            Grupos de Materiales
          </div> -->
          <app-status-filters [selectedStatuses]="selectedStatuses" [showStatus]="[1,0]" [typeFilter]="'master'"
            (selectionFilterApply)="findAllWithCount()">
          </app-status-filters>
        </div>
        <!-- Actions -->
        <div class="mt-6 flex flex-col sm:flex-row shrink-0 sm:items-center space-x-3 sm:ml-4 sm:mt-0">
          <mat-slide-toggle style="margin-top: 0.7em; margin-right: 2em;" color="primary" [(ngModel)]="modeTree">
            Modo Árbol
          </mat-slide-toggle>

          <button mat-stroked-button *ngIf="!isEditSort" color="primary" (click)="isEditSort=!isEditSort">
            <mat-icon svgIcon="heroicons_solid:arrows-up-down"></mat-icon>
            <span>Editar Posición</span>
          </button>
          <button class="ml-3 hidden sm:inline-flex" mat-flat-button [color]="'primary'"
            (click)="onExportButtonPressed()" matTooltip="Exportar">
            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:document-arrow-down'"></mat-icon>
            <span class="ml-2">Exportar</span>
          </button>
          <button mat-icon-button *ngIf="isEditSort" (click)="onsaveChangesOrder()" matTooltip="Guardar">
            <mat-icon color="success" svgIcon="mat_outline:save"></mat-icon>
          </button>
          <!-- <button mat-icon-button *ngIf="isEditSort" (click)="isEditSort=!isEditSort" matTooltip="Cancelar Posición">
            <mat-icon color="warn" svgIcon="heroicons_outline:x-mark"></mat-icon>
          </button> -->

          <!-- Add button (only icon) -->
          <button mat-icon-button color="primary" (click)="openCreateModal()" matTooltip="Crear nuevo">
            <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
          </button>
        </div>
      </div>
    </div>
    <div class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
      <!-- Main Content (Table and Paginator) -->
      <div class="pt-1 mx-6">
        <!-- Tabla -->
        <div *ngIf="!modeTree" class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
          <div class="overflow-auto flex-1 dark:bg-gray-900">
            <table class="w-full bg-transparent" mat-table [dataSource]="dataSource" matSort matSortDisableClear
              multiTemplateDataRows cdkDropList #listGroup="cdkDropList" [cdkDropListData]="dataSource.data"
              (cdkDropListDropped)="onListDrop($event)">
              <!-- Código y nombre -->
              <ng-container matColumnDef="code">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <span>Grupo de Material</span>
                </th>
                <td mat-cell *matCellDef="let materialGroup" class="text-sm uppercase leading-tight">
                  <div class="flex">
                    <div>
                      <b style="font-size:10px;">{{ materialGroup.code }}</b><br>
                      {{ materialGroup.name }}
                    </div>
                  </div>
                </td>
              </ng-container>

              <!-- Tipo -->
              <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Tipo
                </th>
                <td mat-cell *matCellDef="let materialGroup" class="text-sm uppercase">
                  {{ materialGroup.type === 'N' ? 'Normal' : materialGroup.type }}
                </td>
              </ng-container>

              <!-- Compañía -->
              <ng-container matColumnDef="company">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Compañía
                </th>
                <td mat-cell *matCellDef="let materialGroup" class="text-sm uppercase">
                  <div>
                    <b>{{ materialGroup.company.code }}</b>
                  </div>
                  <div>{{ materialGroup.company.name }}</div>
                </td>
              </ng-container>

              <!-- División -->
              <ng-container matColumnDef="division">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  División
                </th>
                <td mat-cell *matCellDef="let materialGroup" class="text-sm uppercase leading-tight">
                  <div>
                    <b style="font-size: 12px;">{{ materialGroup.division.code }}</b>
                  </div>
                  <div>{{ materialGroup.division.name }}</div>
                </td>
              </ng-container>

              <!-- Subcategorías -->
              <ng-container matColumnDef="hasSubcategories">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Subcategorías
                </th>
                <td mat-cell *matCellDef="let materialGroup" class="text-sm uppercase">
                  {{ materialGroup.hasSubcategories ? "Sí" : "No" }}
                </td>
              </ng-container>

              <!-- Estado (mat-slide-toggle) -->
              <ng-container matColumnDef="statusId">
                <th mat-header-cell *matHeaderCellDef>
                  Estado
                </th>
                <td mat-cell *matCellDef="let materialGroup">
                  <mat-slide-toggle [checked]="materialGroup.statusId === 1"
                    (change)="onStatusChange($event.checked, materialGroup)" color="primary">
                  </mat-slide-toggle>
                </td>
              </ng-container>

              <!-- Acciones -->
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="px-6 py-3 text-left"></th>
                <td mat-cell *matCellDef="let materialGroup" class="px-6 py-3 text-left">
                  <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #actionMenu="matMenu">
                    <button mat-menu-item (click)="openEditModal(materialGroup)">
                      <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                      <span>Editar Registro</span>
                    </button>
                    <button mat-menu-item (click)="openDeleteDialog(materialGroup)">
                      <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                      <span>Eliminar Registro</span>
                    </button>
                  </mat-menu>
                </td>
              </ng-container>
              <!-- Header Row -->
              <tr mat-header-row *matHeaderRowDef="displayedColumns"
                class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>
              <!-- Fila principal -->
              <tr mat-row *matRowDef="let row; columns: displayedColumns" cdkDrag [cdkDragData]="row"
                [cdkDragDisabled]="!isEditSort" [ngStyle]="{'cursor': isEditSort ? 'ns-resize' : 'null'}"
                class="border-b"></tr>
            </table>
          </div>
          <!-- Paginación -->
          <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
            <mat-paginator class="z-10" [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons
              [length]="totalItems" [pageSize]="pageSize" (page)="onPageChange($event)">
            </mat-paginator>
          </div>
        </div>

        <div *ngIf="modeTree" class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
          <div class="flex flex-auto overflow-hidden flex-col">
            <!-- Tabla -->
            <div class="overflow-auto flex-1 dark:bg-gray-900">
              <!-- Header -->
              <table class="w-full bg-transparent" mat-table [dataSource]="dataSourceTree" matSort matSortDisableClear
                multiTemplateDataRows cdkDropList #listGroup="cdkDropList" [cdkDropListData]="dataSourceTree.data"
                (cdkDropListDropped)="onListDrop($event)">
                <!-- Código y nombre -->
                <ng-container matColumnDef="code">
                  <th mat-header-cell *matHeaderCellDef>
                    <span [style.paddingLeft.px]="30">Grupo de Material</span>
                  </th>
                  <td mat-cell *matCellDef="let materialGroup" class="text-sm uppercase leading-tight">
                    <div class="flex">
                      <button mat-icon-button [style.visibility]="!materialGroup?.expandable ? 'hidden' : ''"
                        [style.marginLeft.px]="materialGroup?.levelTree * 10"
                        (click)="treeControl.toggle(materialGroup)">
                        <mat-icon color="primary" class="mat-icon-rtl-mirror">
                          {{treeControl.isExpanded(materialGroup) ? 'expand_more' : 'chevron_right'}}
                        </mat-icon>
                      </button>
                      <div>
                        <b style="font-size:12px;">{{ materialGroup.code }}</b><br>
                        {{ materialGroup.name }}
                      </div>
                    </div>
                  </td>
                </ng-container>

                <!-- Tipo -->
                <ng-container matColumnDef="type">
                  <th mat-header-cell *matHeaderCellDef>
                    Tipo
                  </th>
                  <td mat-cell *matCellDef="let materialGroup" class="text-sm uppercase">
                    {{ materialGroup.type === 'N' ? 'Normal' : materialGroup.type }}
                  </td>
                </ng-container>

                <!-- Compañía -->
                <ng-container matColumnDef="company">
                  <th mat-header-cell *matHeaderCellDef>
                    Compañía
                  </th>
                  <td mat-cell *matCellDef="let materialGroup" class="text-sm uppercase">
                    <div>
                      <b>{{ materialGroup.company.code }}</b>
                    </div>
                    <div>{{ materialGroup.company.name }}</div>
                  </td>
                </ng-container>

                <!-- División -->
                <ng-container matColumnDef="division">
                  <th mat-header-cell *matHeaderCellDef>
                    División
                  </th>
                  <td mat-cell *matCellDef="let materialGroup" class="text-sm uppercase">
                    <div>
                      <b style="font-size: 12px;">{{ materialGroup.division.code }}</b>
                    </div>
                    <div>{{ materialGroup.division.name }}</div>
                  </td>
                </ng-container>

                <!-- Subcategorías -->
                <ng-container matColumnDef="hasSubcategories">
                  <th mat-header-cell *matHeaderCellDef>
                    Subcategorías
                  </th>
                  <td mat-cell *matCellDef="let materialGroup" class="text-sm uppercase">
                    {{ materialGroup.hasSubcategories ? "Sí" : "No" }}
                  </td>
                </ng-container>

                <!-- Estado (mat-slide-toggle) -->
                <ng-container matColumnDef="statusId">
                  <th mat-header-cell *matHeaderCellDef class="px-6 text-left">
                    Estado
                  </th>
                  <td mat-cell *matCellDef="let materialGroup" class="px-6 text-left">
                    <mat-slide-toggle [checked]="materialGroup.statusId === 1"
                      (change)="onStatusChange($event.checked, materialGroup)" color="primary">
                    </mat-slide-toggle>
                  </td>
                </ng-container>

                <!-- Acciones -->
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef class="px-6 py-3 text-left"></th>
                  <td mat-cell *matCellDef="let materialGroup" class="px-6 py-3 text-left">
                    <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #actionMenu="matMenu">
                      <button mat-menu-item (click)="openEditModal(materialGroup)">
                        <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                        <span>Editar Registro</span>
                      </button>
                      <button mat-menu-item (click)="openDeleteDialog(materialGroup)">
                        <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                        <span>Eliminar Registro</span>
                      </button>
                    </mat-menu>
                  </td>
                </ng-container>
                <!-- Header Row -->
                <tr mat-header-row *matHeaderRowDef="displayedColumnsTree"
                  class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsTree" cdkDrag [cdkDragData]="row"
                  [cdkDragDisabled]="!isEditSort" [ngStyle]="{'cursor': isEditSort ? 'ns-resize' : 'null'}"
                  class="border-b"></tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modales -->
    <ng-template #addModal>
      <h2 mat-dialog-title class="text-lg font-bold mb-1">Nuevo Registro</h2>
      <mat-dialog-content class="modal-content">
        <form #createForm="ngForm" class="grid grid-cols-2 gap-4">

          <mat-form-field appearance="fill" class="col-span-1">
            <mat-label>Código</mat-label>
            <input matInput [(ngModel)]="currentCreateMaterialGroup.code" name="code" />
          </mat-form-field>
          <!-- <mat-form-field appearance="fill" class="col-span-1">
            <mat-label>External Keys</mat-label>
            <input matInput [(ngModel)]="currentCreateMaterialGroup.externalKeys.code" name="external" required>
          </mat-form-field> -->
          <mat-form-field appearance="fill" class="col-span-1">
            <mat-label>Tipo</mat-label>
            <mat-select [(ngModel)]="currentCreateMaterialGroup.type" name="type" required>
              <mat-option *ngFor="let type of typeList" [value]="type.code">{{ type.name }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="fill" class="col-span-1">
            <mat-label>Nombre</mat-label>
            <input matInput [(ngModel)]="currentCreateMaterialGroup.name" name="name" required />
          </mat-form-field>

          <mat-form-field appearance="fill" class="col-span-1">
            <mat-label for="group-select">Requisitos</mat-label>
            <mat-select name="requirementId" [(ngModel)]="currentCreateMaterialGroup.requirementId"
              placeholder="Seleccione requisitos(s)" multiple>
              <mat-option *ngFor="let req of requirementList" [value]="req._id">{{ req.name }}</mat-option>
            </mat-select>
          </mat-form-field>

          <div class="flex items-center">
            <span class="slide">¿Tiene Subcategorías?</span>
            <mat-slide-toggle [(ngModel)]="currentCreateMaterialGroup.hasSubcategories" name="hasSubcategories"
              color="primary">
            </mat-slide-toggle>
          </div>

          <!-- ng-select for fatherCode -->
          <mat-form-field appearance="fill"
            class="col-span-1"><!--*ngIf="this.currentCreateMaterialGroup.hasSubcategories" -->
            <mat-label>Selecciona el Padre</mat-label>
            <mat-select [(ngModel)]="currentCreateMaterialGroup.fatherCode" name="fatherCode"
              (selectionChange)="onCodeFatherSelectionChange($event.value)" placeholder="Seleccione el padre">
              <mat-option>
                <ngx-mat-select-search [(ngModel)]="searchFather" [ngModelOptions]="{standalone: true}"
                  (ngModelChange)="changueOptionsFather($event)" placeholderLabel="Buscar..."
                  noEntriesFoundLabel="No se encontraron resultados">
                </ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let item of listFilterFatherCode" [value]="item.code">
                <ng-container *ngIf="getCode(item) as code">
                  <b class="f-12">{{ code }}</b> -
                </ng-container>
                {{ item.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- ng-select for Compañía -->
          <div class="col-span-1">
            <label>Compañía</label>
            <ng-select [(ngModel)]="currentCreateMaterialGroup.companyId" [items]="companyList" bindLabel="name"
              bindValue="_id" [searchable]="true" placeholder="Seleccione una compañía" name="companyId"
              [appendTo]="'body'" required>
            </ng-select>
          </div>

          <!-- ng-select for División -->
          <div class="col-span-1">
            <label>División</label>
            <ng-select [(ngModel)]="currentCreateMaterialGroup.divisionId" [items]="divisionList" bindLabel="name"
              bindValue="_id" [searchable]="true" placeholder="Seleccione una división" name="divisionId"
              [appendTo]="'body'" required>
            </ng-select>
          </div>
          <!-- 
          <mat-form-field appearance="fill" class="col-span-1">
            <mat-label>Posición</mat-label>
            <input matInput [(ngModel)]="currentCreateMaterialGroup.position" name="position" type="number" required>
          </mat-form-field> -->
        </form>
      </mat-dialog-content>
      <mat-dialog-actions class="modal-actions flex">
        <button mat-button mat-dialog-close class="align-left">Cancelar</button>
        <button mat-raised-button color="primary" (click)="createMaterialGroup()" [disabled]="!createForm.valid"
          class="justify-end">
          Guardar
        </button>
      </mat-dialog-actions>
    </ng-template>

    <!-- Modal Editar -->
    <ng-template #editModal>
      <h2 mat-dialog-title class="text-lg font-bold mb-1">Editar Registro</h2>
      <mat-dialog-content class="modal-content">
        <mat-tab-group>
          <mat-tab label="Datos Generales">
            <form #editForm="ngForm" class="grid grid-cols-2 gap-4">
              <!-- Nombre -->

              <!-- External-->
              <!-- <mat-form-field appearance="fill" class="col-span-1">
            <mat-label>External Keys</mat-label>
            <input matInput [(ngModel)]="currentUpdateMaterialGroup.externalKeys.code" name="external" required>
          </mat-form-field> -->
              <!-- Código -->
              <mat-form-field appearance="fill" class="col-span-1">
                <mat-label>Código</mat-label>
                <input matInput [(ngModel)]="currentUpdateMaterialGroup.code" name="code" disabled />
              </mat-form-field>

              <!-- Tipo -->
              <mat-form-field appearance="fill" class="col-span-1">
                <mat-label>Tipo</mat-label>
                <mat-select [(ngModel)]="currentUpdateMaterialGroup.type" name="type" required>
                  <mat-option *ngFor="let type of typeList" [value]="type.code">{{ type.name }}</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="fill" class="col-span-1">
                <mat-label>Nombre</mat-label>
                <input matInput [(ngModel)]="currentUpdateMaterialGroup.name" name="name" required />
              </mat-form-field>

              <mat-form-field appearance="fill" class="col-span-1">
                <mat-label for="group-select">Requisitos</mat-label>
                <mat-select name="requirements" [(ngModel)]="currentUpdateMaterialGroup.requirements"
                  placeholder="Seleccione requisito(s)" multiple>
                  <mat-option *ngFor="let req of requirementList" [value]="req._id">{{ req.name }}</mat-option>
                </mat-select>
              </mat-form-field>

              <!-- Subcategorías (mat-slide-toggle) -->
              <div class="col-span-1 flex items-center">
                <span class="slide">¿Tiene Subcategorías?</span>
                <mat-slide-toggle [(ngModel)]="currentUpdateMaterialGroup.hasSubcategories" name="hasSubcategories"
                  color="primary">
                </mat-slide-toggle>
              </div>

              <mat-form-field appearance="fill" class="col-span-1">
                <mat-label>Selecciona el Padre</mat-label>
                <mat-select [(ngModel)]="currentUpdateMaterialGroup.fatherCode" name="fatherCode"
                  (selectionChange)="onCodeFatherSelectionChange($event.value)" placeholder="Seleccione el padre">
                  <mat-option>
                    <ngx-mat-select-search [(ngModel)]="searchFather" [ngModelOptions]="{standalone: true}"
                      (ngModelChange)="changueOptionsFather($event)" placeholderLabel="Buscar..."
                      noEntriesFoundLabel="No se encontraron resultados">
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let item of listFilterFatherCode" [value]="item.code">
                    <ng-container *ngIf="getCode(item) as code">
                      <b class="f-12">{{ code }}</b> -
                    </ng-container>
                    {{ item.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <!-- Compañía (ng-select) -->
              <div class="col-span-1">
                <label>Compañía</label>
                <ng-select [(ngModel)]="currentUpdateMaterialGroup.company" [items]="companyList" bindLabel="name"
                  bindValue="_id" [searchable]="true" placeholder="Seleccione una compañía" name="companyId"
                  (ngModelChange)="onCompanySelectionChange($event)" [compareWith]="compareById" [appendTo]="'body'"
                  required>
                </ng-select>
              </div>

              <!-- División (ng-select) -->
              <div class="col-span-1">
                <label>División</label>
                <ng-select [(ngModel)]="currentUpdateMaterialGroup.division" [items]="divisionList" bindLabel="name"
                  bindValue="_id" [searchable]="true" placeholder="Seleccione una división" name="divisionId"
                  (ngModelChange)="onDivisionSelectionChange($event)" [appendTo]="'body'" [compareWith]="compareById"
                  required>
                </ng-select>
              </div>

              <!-- Posición -->
              <!-- <mat-form-field appearance="fill" class="col-span-1">
            <mat-label>Posición</mat-label>
            <input matInput type="number" [(ngModel)]="currentUpdateMaterialGroup.position" name="position" required>
          </mat-form-field> -->

            </form>
          </mat-tab>
          <mat-tab label="Ventanas Horarias de Entrega">
            <div class="table-container">
              <table mat-table [dataSource]="currentUpdateMaterialGroup.orderDeliveryWindows">
                <!-- Define columns here -->
                <ng-container matColumnDef="days">
                  <th mat-header-cell *matHeaderCellDef>Dias</th>
                  <td mat-cell *matCellDef="let element">
                    {{ getDayNames(element.days) || "N/A" }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="hourStart">
                  <th mat-header-cell *matHeaderCellDef>Hora de Inicio</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.hourStart }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="hourEnd">
                  <th mat-header-cell *matHeaderCellDef>Hora Fin</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.hourEnd }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="numberOfHoursToDelivery">
                  <th mat-header-cell *matHeaderCellDef>Horas para Entrega</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.numberOfHoursToDelivery }}
                  </td>
                </ng-container>

                <!-- Estado (mat-slide-toggle) -->
                <ng-container matColumnDef="statusId">
                  <th mat-header-cell *matHeaderCellDef class="px-6 text-left">
                    Estado
                  </th>
                  <td mat-cell *matCellDef="let element" class="px-6 text-left">
                    <mat-slide-toggle [checked]="element.statusId === 1"
                      (change)="onStatusChangeOrder($event.checked, element)" color="primary">
                    </mat-slide-toggle>
                  </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef>
                    <button color="primary" mat-button (click)="openOrderModal()" matTooltip="Nuevo Registro">
                      <mat-icon svgIcon="heroicons_solid:plus"></mat-icon>
                    </button>
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <div class="button-container">
                      <button mat-icon-button (click)="openOrderModal(element)">
                        <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                      </button>
                      <button mat-icon-button (click)="openDeleteOrder(element)">
                        <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                      </button>
                    </div>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnsOrder"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsOrder"></tr>
              </table>
            </div>
          </mat-tab>
        </mat-tab-group>
      </mat-dialog-content>
      <mat-dialog-actions class="modal-actions flex">
        <button mat-button mat-dialog-close class="align-left">Cancelar</button>
        <button mat-raised-button color="primary" (click)="updateMaterialGroup(currentUpdateMaterialGroup._id)"
          [disabled]="!editForm.valid">
          Guardar
        </button>
      </mat-dialog-actions>
    </ng-template>

    <!-- Modal Eliminar -->
    <ng-template #deleteDialog let-data>
      <div class="flex items-start space-x-2 mb-4">
        <div class="flex items-center">
          <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500 ml-4 mt-6"
            style="font-size: 32px"></mat-icon>
        </div>
        <div class="grid">
          <h2 mat-dialog-title class="text-lg font-bold mb-1">
            Confirmar eliminación
          </h2>
          <mat-dialog-content class="modal-content mt-0">
            <p>¿Está seguro que desea eliminar el registro?</p>
          </mat-dialog-content>
        </div>
      </div>
      <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">
          Conservar
        </button>
        <button mat-raised-button color="warn" [mat-dialog-close]="true">
          Eliminar
        </button>
      </mat-dialog-actions>
    </ng-template>
  </div>

  <!-- Filtros -->
  <app-filter (onFilterEvent)="findAllWithCount()" (onCleanEvent)="clearFilters()" (onPanelOpened)="onFilterPanelOpened()">
    <app-configuration-filters [form]="form" [company]="true" [division]="true" [loadData]="loadFiltersData"></app-configuration-filters>
    <app-materials-management-filters [resetTrigger]="resetTrigger"
      (materialGroupChange)="onMaterialGroupFilterChange($event)" [form]="form"
      [materialGroup]="true" [loadData]="loadFiltersData"></app-materials-management-filters>
  </app-filter>
</mat-sidenav-container>